let defaultBaseURL = '';
let defaultTimeout = 15000;
let defaultHeaders = { 'Content-Type': 'application/json' };
let authToken = '';

const toURL = (path, baseURL) => {
  try {
    return new URL(path, baseURL || window.location.origin).toString();
  } catch (_) {
    return path;
  }
};

export const setBaseURL = (url) => {
  defaultBaseURL = url || '';
};

export const setTimeoutMs = (ms) => {
  defaultTimeout = Number(ms) || defaultTimeout;
};

export const setDefaultHeaders = (headers) => {
  defaultHeaders = { ...defaultHeaders, ...(headers || {}) };
};

export const setApiKey = (key) => {
  if (key) {
    defaultHeaders = { ...defaultHeaders, apikey: key };
    try {
      localStorage.setItem('api_key', key);
    } catch (e) {
      void e;
    }
  }
};

export const setToken = (token) => {
  authToken = token || '';
};

const buildHeaders = (headers, withAuth = true) => {
  const merged = { ...defaultHeaders, ...(headers || {}) };
  const apiKey = merged.apikey || localStorage.getItem('api_key') || '';
  if (apiKey && !merged.apikey) {
    merged.apikey = apiKey;
  }
  if (withAuth) {
    const token =
      authToken ||
      localStorage.getItem('access_token') ||
      localStorage.getItem('token') ||
      '';
    if (token) {
      merged.Authorization = `Bearer ${token}`;
    }
  }
  return merged;
};

const parseBody = async (res) => {
  const ct = res.headers.get('content-type') || '';
  if (ct.includes('application/json')) {
    return res.json();
  }
  return res.text();
};

export const request = async (path, options = {}) => {
  const method = (options.method || 'GET').toUpperCase();
  const params = options.params || undefined;
  const body = options.body;
  const withAuth = options.withAuth ?? true;
  const headers = buildHeaders(options.headers, withAuth);
  const baseURL = options.baseURL ?? defaultBaseURL;
  const timeout = options.timeout ?? defaultTimeout;
  const ctOverride = options.contentType;

  let url = toURL(path, baseURL);
  if (params && typeof params === 'object') {
    const u = new URL(url, window.location.origin);
    Object.keys(params).forEach((k) => {
      const v = params[k];
      if (v !== undefined && v !== null) {
        u.searchParams.append(k, String(v));
      }
    });
    url = u.toString();
  }

  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeout);

  const isForm =
    typeof FormData !== 'undefined' && body instanceof FormData;
  if (isForm || ctOverride === null) {
    delete headers['Content-Type'];
    delete headers['content-type'];
  } else if (typeof ctOverride === 'string' && ctOverride) {
    headers['Content-Type'] = ctOverride;
  }

  const init = { method, headers, signal: controller.signal };
  if (body !== undefined) {
    if (
      headers['Content-Type'] === 'application/json' &&
      typeof body !== 'string'
    ) {
      init.body = JSON.stringify(body);
    } else {
      init.body = body;
    }
  }

  let res;
  try {
    res = await fetch(url, init);
  } finally {
    clearTimeout(timer);
  }

  const data = await parseBody(res);
  if (!res.ok) {
    const err = new Error((data && data.message) || res.statusText);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
};

export const get = (path, options = {}) =>
  request(path, { ...options, method: 'GET' });
export const post = (path, body, options = {}) =>
  request(path, { ...options, method: 'POST', body });
export const put = (path, body, options = {}) =>
  request(path, { ...options, method: 'PUT', body });
export const del = (path, options = {}) =>
  request(path, { ...options, method: 'DELETE' });

export default request;
